import React from "react";
import UpdatePassword from "./UpdatePassword";
import { useCurrentUser } from "../authentication/useCurrentUser";

const SecuritySettings = () => {
    const { user } = useCurrentUser();

    return (
        <div className="space-y-8">
            <div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white">Security Settings</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">Manage your account security and authentication</p>
            </div>

            {/* Email Settings */}
            <div className="rounded-xl border border-gray-200 p-5 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                <h4 className="mb-2 text-sm font-semibold text-gray-900 dark:text-white">Change Email Address</h4>
                <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">
                    Update your email address. You'll need to verify with an OTP sent to your current email.
                </p>
                <div className="space-y-4">
                    <div>
                        <label className="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">Current Email</label>
                        <input
                            type="text"
                            value={user?.email || ''}
                            disabled
                            className="w-full rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300"
                        />
                    </div>
                    <div>
                        <label className="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">New Email Address</label>
                        <input
                            type="email"
                            placeholder="Enter new email"
                            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary dark:border-gray-600 dark:bg-gray-800 dark:text-white"
                        />
                    </div>
                    <div className="flex justify-end">
                        <button className="rounded-lg bg-primary/10 px-4 py-2 text-sm font-medium text-primary hover:bg-primary/20">
                            Send Verification Code
                        </button>
                    </div>
                </div>
            </div>

            {/* Password Settings */}
            <div className="rounded-xl border border-gray-200 p-5 dark:border-gray-700">
                <h4 className="mb-2 text-sm font-semibold text-gray-900 dark:text-white">Change Password</h4>
                <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">
                    Update your password. You'll need to verify with an OTP sent to your email.
                </p>
                <UpdatePassword inModal={true} />
            </div>

            {/* Biometric */}
            <div className="rounded-xl border border-gray-200 p-5 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                <h4 className="mb-2 text-sm font-semibold text-gray-900 dark:text-white">Biometric Authentication</h4>
                <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">
                    Use fingerprint or face recognition to sign in
                </p>
                <button className="flex items-center gap-2 rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M7 20.25h10" />
                    </svg>
                    Setup Biometric Login
                </button>
            </div>
        </div>
    );
};

export default SecuritySettings;
